import { id } from 'date-fns/locale';
import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';
export class RouteLineInput {
  aa: number;
  id: number;
  collectionOrderId: number;
  code: string;
  notes: string;
  statusId: number;
  isActive: boolean;
}
//FormInput needs to be updated like the form shape in the router-form-page.tsx

export const gqlGetCollectionOrdersByIds = gql`
  query fetchCollectionOrdersByIds($where: String) {
    getCollectionOrders(where: $where) {
      data {
        id
        code
        notes
        collectionPointId

        collectionpoint {
          name
          addressLine1
          addressArea
          addressCity
          addressDistrict
        }
      }
    }
  }
`;

export const gqlGetRoutes = gql`
  query getRoutes($limit: Int, $offset: Int, $order: String, $where: String) {
    getRoutes(limit: $limit, offset: $offset, order: $order, where: $where) {
      data {
        id
        code
        seriesId
        codePrefix
        codeNumber
        routeDate
        dateCompleted
        vehicleId
        driverId
        notes
        statusId
        vehicle {
          id
          plateNumber
          collectorId
          collector {
            id
            name
          }
        }
        driver {
          id
          name
        }
        state {
          id
          name
        }
        routesLines {
          id
          aa
          collectionOrderId
          statusId
          notes
          isActive
        }
      }
      recordCount
    }
  }
`;
export const gqlGetByIdQuery = gql`
  query getRouteById($id: Int) {
    getRouteById(id: $id) {
      id
      code
      seriesId
      codePrefix
      codeNumber
      routeDate
      dateCompleted
      notes
      driverId
      vehicleId
      statusId
      isActive
      firstDate
      lastDate
      firstUser
      lastUser
      vehicle {
        id
        plateNumber
        collector {
          id
          name
        }
      }
      driver {
        id
        name
      }
      state {
        id
        name
      }
      routesLines {
        id
        aa
        collectionOrderId
        statusId
        notes
        isActive
        state {
          id
          name
        }
        collectionOrder {
          id
          code
          collectionPointId
          notes
          collectionpoint {
            id
            name
            addressLine1
            addressLine2
            addressArea
            addressCity
            addressNomos
            addressDistrict
          }
        }
        collections {
          id
          code
        }
      }
    }
  }
`;

export const gqlAdd = gql`
  mutation addRoute($data: RouteInput) {
    addRoute(data: $data) {
      id
    }
  }
`;

export const gqlUpdate = gql`
  mutation updateRoute($data: RouteInput) {
    updateRoute(data: $data) {
      id
    }
  }
`;

export const gqlDelete = gql`
  mutation deleteRoute($id: Int) {
    deleteRoute(id: $id)
  }
`;
//create deleteRoutesLine function to delete a route line
export const gqlDeleteRoutesLine = gql`
  mutation deleteRoutesLine($id: Int) {
    deleteRoutesLine(id: $id)
  }
`;
export const qglReleaseRoute = gql`
  mutation completeRouteAndRelease($data: RouteInput) {
    completeRouteAndRelease(data: $data) {
      id
    }
  }
`;
